import { render } from "./Treatments.vue?vue&type=template&id=2c3c3321"
import script from "./Treatments.vue?vue&type=script&lang=js"
export * from "./Treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__